@for (holiday of value; track holiday; let index = $index) {
  <div class="btn-group mb-1 me-1" role="group">
    <button type="button" class="btn btn-default">
      <i class="far fa-calendar"></i>&nbsp;
      <span>{{longFormat(holiday.from)}} - {{longFormat(holiday.to)}} &nbsp;</span>
    </button>
    <button type="button" class="btn btn-default" (click)="remove(index)">
      <i class="fal fa-times"></i>
    </button>
  </div>
}

<div class="btn-group d-block" role="group">
  <tm-date-range-picker [formControl]="dateRangeCtrl" [presetIds]="presetIds" [maxDate]="maxDate">
    <button type="button" class="btn btn-default">
      <i class="far fa-plus"></i>&nbsp;
      <span>{{'selectVacationPeriod' | translate}}&nbsp;</span>
      <i class="far fa-caret-down"></i>
    </button>
  </tm-date-range-picker>
</div>